<template>
  <v-app id="v-app" :style="$route.name==='mainPageUser' ? 'background: #E4E4E4 !important;':''" class="background-color" style="position: relative">
    <navbar :user="userInfo" v-if="$route.name!=='login' && $route.name!=='signup' && $route.name!=='forgot'"></navbar>
    <router-view :style="!$vuetify.breakpoint.smAndDown ? 'padding-right: 104px; padding-left: 24px' : ''"></router-view>
    <div class="alert-parent" style="position: fixed; bottom: 20px; left: 20px;">
      <v-alert class="alert"
               height="55"
               dismissible
               :color="item.type"
               v-for="(item, index) in messages"
               :key="index">
        {{ item.text }}
      </v-alert>
    </div>
<!--    <v-btn-->
<!--        x-large-->
<!--        @click="printAlert({type: 'info', text:'Hiii', timeout:5000})"-->
<!--    >DOKME</v-btn>-->
<!--    <v-text-field v-model="data.type"></v-text-field>-->
<!--    <v-text-field v-model="data.text"></v-text-field>-->
      <div  v-if="$route.name === 'login'" style="display: flex; flex-direction: column; margin-top: -10px; align-items: flex-end; padding-bottom: 10px; position: absolute; bottom: 0; left: 15px">
          <span class="white--text" style="font-weight: 400; font-size: .75rem">Dot
            <span class="white--text" style="font-weight: 200; font-size: .75rem; letter-spacing: 1.7px; margin-top: 3px">{{version}}</span>
          </span>
      </div>
      <div v-if="$route.name !== 'login'" style="display: flex; flex-direction: column; margin-top: 20px; align-items: flex-end; left: 24px; padding-bottom: 10px; position: absolute; bottom: 0; align-content: end">
          <span class="grey--text" style="font-weight: 400; font-size: .75rem">Dot
            <span class="grey--text" style="font-weight: 200; font-size: .75rem; letter-spacing: 1.7px;">{{version}}</span>
          </span>
      </div>
  </v-app>
</template>

<script>

import {mapActions, mapGetters, mapState} from "vuex"
import navbar from "./components/userMainPageComponent/navbar";
import integration from "./mixin/integration";
export default {
  name: 'App',
  components:{
    navbar,
  },

  data: () => ({
    timeOut: true,
    version: process.env.VUE_APP_VERSION
  }),
  mixins:[integration],
  methods: {
    ...mapActions({
        printAlert:'alert/printAlert',
        fetchUserInfo:'user/fetchUserInfo'
    }),
    // showAlert (type) {
    //   this.type = type
    //
    //
    //   let timer = this.showAlert.timer
    //
    //   if (timer) {
    //
    //     clearTimeout(timer)
    //   }
    //   this.showAlert.timer = setTimeout(() => {
    //     this.type = null
    //
    //   }, 3000)
    //
      // this.elapse = 1
      // let t = this.showAlert.t
      // if (t) {
      //   clearInterval(t)
      // }
      //
      // this.showAlert.t = setInterval(() => {
      //   if (this.elapse === 3) {
      //     this.elapse = 0
      //     clearInterval(this.showAlert.t)
      //   }
      //   else {
      //     this.elapse++
      //   }
      // }, 1000)
    // }
    // print() {
    //
      // const { type, text } = this.payload
      // const payload = {
      //   type,
      //   text
      // }
    //   this.printAlert(message);
    //
    // }
  },
  computed: {
    ...mapGetters({
      messages: 'alert/getMessageInfo',
      userInfo:"user/getUserProfile"
    }),
    ...mapState({
      info: 'alert/message'
    })
  },
  async mounted() {
    await this.fetchUserInfo()
    if(this.userInfo.integration !== undefined && this.userInfo.integration.length > 0){
      //برای نشان دادن قسمت ایشو سلکت
      this.userInfo.integration.map((item) => {
        if (item.name === 'redmine') {
          this.$store.state.isIntegrationSet = true
        }
      })
    }
  },
  async created() {
    await this.fetchUserInfo()
    this.checkHasIntegration()
  }
}
</script>
<style>
* {
  font-family: iranYekan;
}
.alert-parent{
    /*margin-right: 30px;*/
    width: max-content;
}
.alert {
  /*left: 78px;*/
  /*bottom: 96px;*/
  width: 320px;
  /*height: 50px;*/
  border-radius: 27px !important;
}
.alert-parent .theme--light.v-sheet {
  color: White!important;
}
.v-alert__content {
  display: flex;
  justify-content: start;
    margin: 0 5px;
}
    @font-face {
        font-family: iranYekan;
        src:
            /* url("./assets/fonts/woff/KalamehWeb_Black.woff"),
            url("./assets/fonts/woff2/KalamehWeb_Black.woff2"), */
                url("./assets/fonts/ttf/IRANYekanWebBlack.ttf");
        /* url("./assets/fonts/eot/KalamehWeb_Black.eot"); */
        font-weight: 900;
    }
    @font-face{
        font-family: iranYekan;
        src:
            /* url("./assets/fonts/woff/KalamehWeb_Bold.woff"), */
            /* url("./assets/fonts/woff2/KalamehWeb_Bold.woff2"), */
                url("./assets/fonts/ttf/IRANYekanWebBold.ttf");
            /* url("./assets/fonts/eot/KalamehWeb_Bold.eot"); */
        font-weight: bold;
    }
    @font-face{
        font-family: iranYekan;
        /* src: url("./assets/fonts/woff/KalamehWeb_Regular.woff"), */
        /* url("./assets/fonts/woff2/KalamehWeb_Regular.woff2"), */
        src: url("./assets/fonts/ttf/IRANYekanWebRegular.ttf");
        font-weight: normal;
    }
    @font-face{
        font-family: iranYekan;
        src: url("./assets/fonts/ttf/IRANYekanWebThin.ttf");
        font-weight: 100;
    }

    @font-face {
        font-family: iranYekan;
        src: url("./assets/fonts/ttf/IRANYekanWebLight.ttf");
        font-weight: 200;
    }
    @font-face {
        font-family: iranYekan;
        src: url("./assets/fonts/ttf/IRANYekanWebMedium.ttf");
        font-weight: 300;
    }

    .theme--light.v-application{
        background: #E4E4E4 !important;
    }
    * {
      letter-spacing: normal;
    }
    @media screen and (max-width: 400px) {
        .alert-parent{
            margin: 0 auto;

        }
        .alert{
            width: 300px;
        }
    }
/* width */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/* Track */
::-webkit-scrollbar-track-piece {
  /*box-shadow: inset 0 0 5px grey;*/
  /*background-color: red;*/
  border-radius: 50px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background-color: #1FCFB5;
  border-radius: 10px;
}
</style>
<style scoped>
    .background-color{
        background-color: #E4E4E4;
    }
    @media screen and (max-width: 600px) {
       .alert-parent{
           bottom: 100px !important;
         /*padding-bottom: 4.5rem;*/
       }
    }
</style>
